import { combineReducers } from "redux";
import authReducer from "./reducers/authAction/index";

const rootReducer = combineReducers({
  authReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
